import { DownloadIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Spinner } from "@/components/ui/spinner";
import { useDescargarCotizacion } from "@/hooks/useDescargarCotizacion";

/**
 * Descarga el documento de cotización de un informe.
 *
 * REEMPLAZA A LA PANTALLA DE PREVISUALIZACIÓN, que embebía el PDF en un visor.
 * Lo que el equipo necesita es el archivo —para mandarlo, imprimirlo o
 * guardarlo—, y un visor dentro de la aplicación es un paso de más entre la
 * persona y el documento.
 *
 * NO ES UN `<a href download>`, que sería lo obvio: ese atributo se IGNORA
 * cuando el enlace apunta a otro origen, y el API vive en otro subdominio que
 * el webapp. El binario se trae por `fetch` y se guarda desde un `blob:`
 * propio; el porqué completo está en `descargarArchivo`.
 *
 * MUESTRA QUE ESTÁ TRABAJANDO, y no es adorno: el documento pesa cerca de un
 * mega y en una conexión lenta el botón queda un rato sin dar señales. Sin el
 * spinner, la reacción natural es apretarlo otra vez.
 */
export function BotonDescargarCotizacion({
  informeId,
  children = "Descargar cotización",
  variant = "outline",
  size = "default",
  title,
}: {
  informeId: number;
  children?: React.ReactNode;
  variant?: "default" | "outline" | "secondary" | "soft" | "ghost";
  /** `sm` para las bandejas de acciones de una tabla, donde no cabe el alto normal. */
  size?: "default" | "sm";
  /**
   * Aclara QUÉ documento se baja cuando el rótulo no alcanza.
   *
   * Cuando el botón dice solo "Descargar", el nombre del documento lo pone
   * esto. En el banner, donde el rótulo ya lo dice, sobra.
   */
  title?: string;
}) {
  const { descargando, descargar } = useDescargarCotizacion(informeId);

  return (
    <Button
      type="button"
      variant={variant}
      size={size}
      title={title}
      onClick={descargar}
      disabled={descargando}
    >
      {descargando ? <Spinner /> : <DownloadIcon className="size-4" />}
      {children}
    </Button>
  );
}
